/* Göttfert's theme */

const _logo = './assets/logo/light.svg'
const _devices = './assets/widgets/devices.svg'
const _messages = './assets/widgets/messages.svg'

/**
 * If the "dark" and / or "light" keys are omitted, their value(s) will be calculated from "main",
 * according to the "tonalOffset" value.
 * If "contrastText" is omitted, its value will be calculated to contrast with "main", according to
 * the "contrastThreshold" value.
 *
 * @see https://material-ui.com/customization/palette/
 *
 * @example
 *    stateDescriptor_A: { // stateDescriptor -> warning, error, success, etc
 *     // light: will be calculated from palette.primary.main,
 *     main: '#ff4400',
 *     // dark: will be calculated from palette.primary.main,
 *     // contrastText: will be calculated to contrast with palette.primary.main
 *   },...
 *
 */
export default {
  direction: 'ltr',
  palette: {
    mode: 'light',
    common: {
      black: '#000000',
      white: '#FFFFFF',
    },
    primary: {
      main: '#E85412',
      dark: '#CC4A10',
      darker: '#E85412',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#E85412',
      dark: '#CC4A10',
      darker: '#E85412',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#E40000',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#F8A700',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#0097C4',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#74AC00',
      contrastText: '#FFFFFF',
    },
    signal: {
      main: '#E40000',
      contrastText: '#FFFFFF',
    },
    active: {
      main: '#0097C4',
    },
    inactive: {
      main: '#575757',
    },
    pending: {
      main: '#F8A700',
    },
    text: {
      primary: '#151515',
      secondary: '#7D7E80',
      regular: '#707070',
      light: '#CCCCCC',
      inverted: '#FFFFFF',
      dark: '#181818',
      link: '#0097C4',
      description: '#8C8C8C',
    },
    appBar: {
      toolBar: '#EEEEEE',
      actionBar: '#FFFFFF',
      border: '#EEEEEE',
      text: '#575757',
    },
    divider: '#DDDDDD',
    border: {
      main: '#E6E7E8',
    },
    background: {
      main: '#FFFFFF',
      light: '#F3F5F6',
      dark: '#F6F6F6',
      selected: '#F6F6F6',
      content: '#FAFAFA',
    },
  },
  logo: {
    src: _logo,
    url: `url(${_logo})`,
    backgroundSize: '85%',
  },
  widget: {
    devices: `url(${_devices})`,
    messages: `url(${_messages})`,
  },
}
